"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var residualAmount = {
    RESIDUAL_AMOUNT: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment ResidualAmount on DealFinanceAttributes {\n      residualAmount {\n        currency\n        amount\n      }\n    }\n  "], ["\n    fragment ResidualAmount on DealFinanceAttributes {\n      residualAmount {\n        currency\n        amount\n      }\n    }\n  "]))),
};
exports.default = residualAmount;
var templateObject_1;
